import {MAX_TIMEOUT} from "./constants";

export function longTimeout(callback: () => void, delay: number = 0): () => void {
  let timeoutId: ReturnType<typeof setTimeout>;
  let remaining = delay;

  const start = () => {
    if (remaining <= MAX_TIMEOUT) {
      timeoutId = setTimeout(callback, remaining);
    } else {
      timeoutId = setTimeout(() => {
        remaining -= MAX_TIMEOUT;
        start();
      }, MAX_TIMEOUT);
    }
  };

  start();

  return () => {
    clearTimeout(timeoutId);
  };
}
